import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';
import { WelcomeProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';
// import BicesterCollection from '../../assets/images/map/bicester_collection.png';

const MapWelcome = ({ active, setActive }: WelcomeProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        // onClick={() => setActive()}
      />
      <Box
        zIndex={7}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="rgba(255, 255, 255, 0.99);"
        padding="15px"
        borderRadius="0px"
        width={['95vw', '400px', '700px', '700px', '700px']}
        height={['430px', '430px', '450px', '450px', '450px']}
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
      >
        {/* <Image src={BicesterCollection} w="90px" objectFit="contain" alt="bicester collection" /> */}
        <Text
          textAlign="center"
          fontWeight="300"
          fontSize={['24px', '28px', '36px', '36px', '36px']}
          lineHeight={['28px', '32px', '40px', '40px', '40px']}
          maxW="90%"
          fontFamily="SangBleuBPLight"
          className="copy"
          mt="10"
        >
          {t('map-welcome-title-one')}
          <br />
          {t('map-welcome-title-two')}
          <br />
          {t('map-welcome-title-three')}
        </Text>
        <Text
          fontWeight="400"
          fontFamily="JosefinSans"
          fontSize={['14px', '14px', '14px', '16px', '16px']}
          lineHeight={['18px', '18px', '18px', '20px', '20px']}
          textAlign="center"
          mt="10"
          maxW={['85%', '85%', '60%', '68%']}
          className="copy"
        >
          {t('map-welcome-description')}
        </Text>
        <Button
          margin="0px auto"
          bg="white"
          className="copy"
          border="1px solid grey"
          borderRadius="0px"
          mt={['25px', '25px', '30px', '30px', '30px']}
          p="30px"
          _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
          _focus={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
          onClick={() => setActive()}
        >
          <Text fontSize={['14px', '16px', '20px', '20px', '20px']} casing="uppercase">
            {t('map-welcome-cta')}
          </Text>
        </Button>
      </Box>
    </>
  );
};
export default MapWelcome;
